import { render, staticRenderFns } from "./BProgress.vue?vue&type=template&id=13535d56&"
import script from "./BProgress.vue?vue&type=script&lang=ts&"
export * from "./BProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports